module.exports = __webpack_public_path__ + "static/media/familyGems.44e01299.webp";